import _ from "lodash";
import React, { useMemo } from "react";
import { Tooltip } from "@toddle-edu/ds-web";
import { connect } from "react-redux";

import useI18n from "Hooks/UseI18n";
import { graphql, compose } from "lib/apolloClient";
import {
  getSelectedCurriculumId,
  getSelectedAcademicYearId,
} from "modules/CommonSelectors";
import { getStaffMembersWithPermsQuery } from "AnnouncementsManager/routes/ReviewerSetup/modules/ReviewerSetupQueries";
import {
  getStaffPermsQueryVariables,
  ANNOUNCEMENT_STAFF_PERMS,
  PUBLISH_PERM_VALUES,
} from "AnnouncementsManager/routes/ReviewerSetup/modules/utils";
import { WarningTriangleFilled } from "@toddle-edu/ds-icons";

import classes from "./InvalidConfigWarning.scss";

const overlayInnerStyle = { width: "260px" };

const InvalidConfigWarning = props => {
  const { teacherEdges } = props;
  const { t } = useI18n(["announcement"]);

  const isValidPermConfig = useMemo(() => {
    if (_.isEmpty(teacherEdges)) return true;

    return _.every(teacherEdges, teacherEdge => {
      const { circularReviewers } = teacherEdge.node;
      const configurations = _.get(
        teacherEdge,
        "node.permissions.configuration.configurations",
        []
      );

      const publishPerm = _.find(configurations, {
        id: ANNOUNCEMENT_STAFF_PERMS.ANNOUNCEMENT_PUBLISH.id,
      });

      const permValue =
        JSON.parse(_.get(publishPerm, "value")) ||
        PUBLISH_PERM_VALUES.CREATE_AND_PUBLISH;

      // for create_only perm, circular reviewers should be present
      if (permValue === PUBLISH_PERM_VALUES.CREATE_ONLY) {
        return !_.isEmpty(circularReviewers);
      }

      return true;
    });
  }, [teacherEdges]);

  if (!isValidPermConfig) {
    return (
      <div className={classes.iconWrapper}>
        <Tooltip
          tooltip={t("announcement:invalid_reviewer_config_warning_msg")}
          placement="bottomLeft"
          overlayInnerStyle={overlayInnerStyle}
          showArrow
        >
          <WarningTriangleFilled variant="warning" />
        </Tooltip>
      </div>
    );
  }

  return null;
};

const mapStateToProps = state => ({
  curriculumProgramId: getSelectedCurriculumId(state),
  academicYearId: getSelectedAcademicYearId(state),
});

export default compose(
  connect(mapStateToProps),
  graphql(getStaffMembersWithPermsQuery, {
    name: "getStaffMembersWithPerms",
    options: ({ academicYearId, curriculumProgramId }) => {
      return {
        // Just to subscribe to the cache updates
        fetchPolicy: "cache-only",
        variables: getStaffPermsQueryVariables({
          academicYearId,
          curriculumProgramId,
        }),
      };
    },
    props: ({ getStaffMembersWithPerms }) => {
      const { node } = getStaffMembersWithPerms;
      const teacherEdges = _.get(node, "staff.edges", []);

      return { teacherEdges };
    },
  })
)(InvalidConfigWarning);
